import { useDispatch, useSelector } from "react-redux";
import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";
import React from "react";

import styled from "styled-components";
import { currentlyEditingSleeperSelector } from "../../../../redux/slices/customNavigation";
import {
  primarySleeperPainPointsSelector,
  secondarySleeperPainPointsSelector,
  setPrimarySleeperBackPainHip,
  setPrimarySleeperBackPainLowerBackPain,
  setPrimarySleeperBackPainMidBack,
  setPrimarySleeperBackPainShoulder,
  setSecondarySleeperBackPainHip,
  setSecondarySleeperBackPainLowerBackPain,
  setSecondarySleeperBackPainMidBack,
  setSecondarySleeperBackPainShoulder,
} from "../../../../redux/slices/mattressConfiguration";
import PainPointButton from "../common/PainPointButton";
import painPointHip from "../../../../assets/images/painPoints/painPointHip.svg";
import painPointLowerBackPain from "../../../../assets/images/painPoints/painPointLowerBackPain.svg";
import painPointMidBack from "../../../../assets/images/painPoints/painPointMidBack.svg";
import painPointShoulder from "../../../../assets/images/painPoints/painPointShoulder.svg";

const StyledImageContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const StyledText = styled.div`
  font-family: noto-sans;
  font-weight: bold;
  font-size: 0.82rem;
`;

const StyledContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1rem;
  padding-right: 4vw;
  padding-left: 4vw;
  width: 100%;
`;

const PainPointSelection = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const primarySleeperPainPoints = useSelector(
    primarySleeperPainPointsSelector
  );
  const secondarySleeperPainPoints = useSelector(
    secondarySleeperPainPointsSelector
  );

  const currentlyEditingSleeper = useSelector(currentlyEditingSleeperSelector);

  const editingSleeper1 = currentlyEditingSleeper === 1;

  const handleSetBackPainHip = () => {
    if (editingSleeper1) {
      dispatch(setPrimarySleeperBackPainHip(!primarySleeperPainPoints["hip"]));
    } else {
      dispatch(
        setSecondarySleeperBackPainHip(!secondarySleeperPainPoints["hip"])
      );
    }
  };
  const handleSetBackPainShoulder = () => {
    if (editingSleeper1) {
      dispatch(
        setPrimarySleeperBackPainShoulder(!primarySleeperPainPoints["shoulder"])
      );
    } else {
      dispatch(
        setSecondarySleeperBackPainShoulder(
          !secondarySleeperPainPoints["shoulder"]
        )
      );
    }
  };
  const handleSetBackPainLowerBack = () => {
    if (editingSleeper1) {
      dispatch(
        setPrimarySleeperBackPainLowerBackPain(
          !primarySleeperPainPoints["lowerBack"]
        )
      );
    } else {
      dispatch(
        setSecondarySleeperBackPainLowerBackPain(
          !secondarySleeperPainPoints["lowerBack"]
        )
      );
    }
  };
  const handleSetBackPainLowerBackPain = () => {
    if (editingSleeper1) {
      dispatch(
        setPrimarySleeperBackPainMidBack(!primarySleeperPainPoints["midBack"])
      );
    } else {
      dispatch(
        setSecondarySleeperBackPainMidBack(
          !secondarySleeperPainPoints["midBack"]
        )
      );
    }
  };

  const painPoints1 = [
    {
      image: painPointHip,
      title: t("Hip"),
      id: "hip",
      onClick: handleSetBackPainHip,
    },
    {
      image: painPointShoulder,
      title: t("Shoulder"),
      id: "shoulder",
      onClick: handleSetBackPainShoulder,
    },
  ];
  const painPoints2 = [
    {
      image: painPointLowerBackPain,
      title: t("Lower Back Pain"),
      id: "lowerBack",
      onClick: handleSetBackPainLowerBack,
    },
    {
      image: painPointMidBack,
      title: t("Mid-Back"),
      id: "midBack",
      onClick: handleSetBackPainLowerBackPain,
    },
  ];

  const unselectedSleepStyle = {
    color: theme.COLORS.BLUE.darkBlueGreen,
    width: "60%",
    padding: 0,
    aspectRatio: 1,
    // display: "flex",
    // justifyContent: "flex-start",
    // alignItems: "flex-start",
  };

  const selectedSleepStyle = {
    color: theme.COLORS.BLUE.darkBlueGreen,
    width: "100%",
    padding: 0,
    opacity: 0.4,
  };

  const selectedTextSleepStyle = {
    width: "80%",
    marginTop: "-6vh",
    fontSize: "1rem",
  };
  const getIsSelected = id => {
    return editingSleeper1
      ? primarySleeperPainPoints[id]
      : secondarySleeperPainPoints[id];
  };

  const PainPointsRow = painPointsArray => {
    return (
      <StyledContainer style={{}}>
        {painPointsArray.map((element, index) => {
          const isSelected = getIsSelected(element.id);
          return (
            <PainPointButton
              className="col-6"
              key={element}
              onClick={element.onClick}
              index={index}
            >
              <StyledImageContainer
                style={
                  isSelected === true
                    ? selectedSleepStyle
                    : unselectedSleepStyle
                }
              >
                <img style={{ height: "8vh" }} src={element.image}></img>
              </StyledImageContainer>
              <StyledText
                className={"text-center pain-point-text " + (isSelected ? "selected" : "") }
                style={
                  isSelected === true
                    ? selectedTextSleepStyle
                    : unselectedSleepStyle
                }
              >
                {element.title}
              </StyledText>
            </PainPointButton>
          );
        })}
      </StyledContainer>
    );
  };

  return (
    <>
      {PainPointsRow(painPoints1)}
      {PainPointsRow(painPoints2)}
    </>
  );
};

export default PainPointSelection;
